import React from 'react';

/**
 * ProInfoBox
 * Reusable info-box list showing PRO / Line / Qty for a PRO row.
 *
 * This is the single source of truth for the "[PRO|xxxx] [Line|xxxx] [Qty|xx|UOM]"
 * block that was previously duplicated across many transaction list screens.
 *
 * Usage:
 *   <ProInfoBox pro={row.pro} line={row.line} qty={row.qty} uom={row.uom} />
 */
const ProInfoBox = ({ pro, line, qty, uom }) => (
    <>
        <div className="box-info">
            <div className="left">PRO</div>
            <div className="content">{pro}</div>
        </div>
        <div className="box-info">
            <div className="left">Line</div>
            <div className="content">{line}</div>
        </div>
        <div className="box-info">
            <div className="left">Qty</div>
            <div className="content">{qty}</div>
            <div className="right">{uom}</div>
        </div>
    </>
);

export default ProInfoBox;
